import { Content } from './content';

export class Banner extends Content {

    static tableName = 'banners'

}